import { useCallback } from "react"
import { useAxiosInstances } from "../axios-instance"
import { ProdutosEnum } from "../../presentation/assets/helpers/ProdutosEnum"
import axios from 'axios'

export interface ILoginApiResponse {
  autenticado: boolean
  mensagem: string
  criadoem?: string
  expiraem?: string
  acesso?: string
  token: string
  tokentype?: string
  // Dados extras retornados pelo C# V3
  IdUsuario?: number
  NomeUsuario?: string
  LoginUsuario?: string
  EmailUsuario?: string
  IdPerfil?: number
  Perfil?: string
  Autenticado?: boolean // Para compatibilidade PascalCase direta do C#
  Token?: string
  Mensagem?: string
  CriadoEm?: string
  Acesso?: string
  TokenType?: string
}

export const useAuthApi = () => {
  const { axiosInstance, axiosAuthInstance } = useAxiosInstances()

  const loginApi = useCallback(async (data: {
    loginCliente: string
    loginUsuario: string
    senhaUsuario: string
    idProduto?: number
  }): Promise<ILoginApiResponse> => {
    try {
      const result = await axiosInstance.post('/auth/login', {
        usuario: data.loginUsuario,
        senha: data.senhaUsuario,
        cliente: data.loginCliente,
        idproduto: ProdutosEnum.AUTH_VELES
      })

      return result.data.result
    } catch (error) {
      throw error
    }
  }, [axiosInstance])

  const insertAcessoApi = useCallback(async (data: {
    IdProduto: number
  }): Promise<{
    accessToken: string
    acesso: any
    usuario: any
  }> => {
    try {
      const result = await axiosAuthInstance.post('/auth/acesso', {
        IdProduto: data.IdProduto
      })

      return result.data.result
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  const generateLegacyRedirectApi = useCallback(async (data: {
    IdAcesso: number
    IdProduto: number
  }): Promise<{
    redirectUrl: string
  }> => {
    try {
      const result = await axiosAuthInstance.post('/auth/legacy-redirect', {
        IdAcesso: data.IdAcesso,
        IdProduto: data.IdProduto
      })

      return result.data.result
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  const refreshApi = useCallback(async (token: string): Promise<ILoginApiResponse> => {
    try {
      const authUrl = process.env.REACT_APP_VELES_AUTH_URL
      const result = await axios.get(`${authUrl}/api/validation/refreshTokenv3`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      return result.data
    } catch (error) {
      throw error
    }
  }, [])

  const getSessionTimeoutApi = useCallback(async (): Promise<{ sessionTimeoutSeconds: number }> => {
    try {
      const result = await axiosAuthInstance.get('/auth/session-timeout')
      return result.data.result
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  return {
    loginApi,
    insertAcessoApi,
    generateLegacyRedirectApi,
    refreshApi,
    getSessionTimeoutApi
  }
}
